// @ts-check

import { ICandidateProfile, CandidateProfileModel } from "@core/models";

export const candidateProfileMock = new CandidateProfileModel({
  [ICandidateProfile.extraId]: 12345,
  [ICandidateProfile.firstname]: "Henry",
  [ICandidateProfile.lastname]: "Extracadabra",
  [ICandidateProfile.email]: "contact@extracadabra.com",
  [ICandidateProfile.birthdate]: "2000-01-30",
  [ICandidateProfile.gender]: "homme",
  [ICandidateProfile.street]: "30 rue de la liberté",
  [ICandidateProfile.postalCode]: "75000",
  [ICandidateProfile.city]: "Paris",
  [ICandidateProfile.hasVehicle]: true,
  [ICandidateProfile.phone]: "0645326789",
  [ICandidateProfile.avatar]: "https://fastly.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U",
  [ICandidateProfile.averageNote]: 5,
  [ICandidateProfile.jobsAmount]: 12,
  [ICandidateProfile.isBlocked]: false,
  [ICandidateProfile.about]: "Un candidat de qualité",
});
